import { VerifyCodeType } from './enums';

export const VerifyCodeTypeTitle = {
  [VerifyCodeType.Phone]: 'Phone',
  [VerifyCodeType.Email]: 'Email Address',
};
